import { createContext, use } from "react";

/** When the form is reset (e.g. Revert), RTEs use this revision to call setContent with the new value instead of remounting. */
export const EditorContentRevisionContext = createContext<number>(0);

export const useEditorContentRevision = (): number =>
  use(EditorContentRevisionContext);
